import { useState } from 'react';
import { menuIcon } from '../../../../../configs/Icons';
import InstOption from '../../../../utils/InstOption';
import { OptionTransparentIcon, ReloadGrIcon } from '../../../../utils/SVGIcon';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import ServiceInfoCard from './ServiceInfoCard';

function ButtonWrapper({ children, className, onClick }) {
    return (
        <span className="h-full !block">
            <button
                type="button"
                className={`h-[34px] block text-sm font-e text-secondary bg-[rgba(255,255,255,0.80)] backdrop-blur-[2px] rounded-5 ${className}`}
                onClick={onClick}
            >
                {children}
            </button>
        </span>
    );
}

function ActionArea({ handleReload, openModal, showMenu, setShowMenu }) {
    return (
        <div className="flex items-center gap-x-2.5 absolute top-2 right-2">
            <ButtonWrapper className="w-[34px] p-1" onClick={handleReload}>
                <ReloadGrIcon />
            </ButtonWrapper>
            <div className="relative">
                <ButtonWrapper className="w-[34px]" onClick={() => setShowMenu(!showMenu)}>
                    <span className="w-full block">
                        <OptionTransparentIcon />
                    </span>
                </ButtonWrapper>
                <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                    {/* Service actions */}
                    <button type="button" onClick={() => openModal('edit-service')}>
                        Edit Info
                    </button>
                    <button type="button" onClick={() => openModal('view-activity-log')}>
                        View Activity Log
                    </button>
                </InstOption>
            </div>
        </div>
    );
}

function ServiceDetails({ serviceInfo }) {
    const { id } = serviceInfo;

    return (
        <div className="overflow-hidden">
            <div className="size-[100px] bg-[#E6F6ED] relative rounded-full p-4 mb-4">
                <span className="w-full block">
                    <img src={menuIcon.servicesWL} alt="" className="w-full block" />
                </span>
            </div>
            <div className="flex flex-col ite gap-1">
                <div className="flex flex-row items-center gap-2.5 relative text-primary text-2xl font-medium whitespace-nowrap text-ellipsis overflow-hidden">
                    <span className="overflow-hidden text-ellipsis">
                        {serviceInfo?.serviceName || 'Service'}
                    </span>
                    <span className="bg-warning text-sm text-white py-px px-2.5 rounded-[4px] max-h-[22px]">
                        {TextCapitalize(serviceInfo?.status) || '--'}
                    </span>
                </div>
                <p className="text-sm text-primary">
                    <span>Service ID: {id}</span>
                </p>
                <div>
                    <div className="flex gap-x-2 text-base text-primary">
                        <div className="whitespace-nowrap">
                            <span>Organization:</span>
                        </div>
                        <div className="whitespace-nowrap font-medium">
                            <span>{serviceInfo?.user?.organization || '------'}</span>
                        </div>
                    </div>
                    <div className="flex gap-x-2 text-base text-primary">
                        <div className="whitespace-nowrap">
                            <span>Customer:</span>
                        </div>
                        <div className="whitespace-nowrap">
                            <span>{serviceInfo?.user?.fullName || '------'}</span>
                        </div>
                    </div>
                    <div className="flex gap-x-2 text-base text-primary">
                        <div className="whitespace-nowrap">
                            <span>Product Type:</span>
                        </div>
                        <div className="whitespace-nowrap">
                            <span>{TextCapitalize(serviceInfo?.productType) || '------'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ServiceInfo({ data, handleReload, openModal }) {
    const [showMenu, setShowMenu] = useState(false);

    return (
        <div
            className={`product-bg relative w-full h-auto min-h-[250px] p-2.5 mb-4 2xl:flex justify-between 2xl:gap-3 ${
                data?.demo ? 'placeholder-mode' : ''
            }`}
        >
            {/* service information */}
            <div className="flex flex-1 items-center pl-5 relative z-20 mb-9">
                <ServiceDetails serviceInfo={data} />
            </div>

            {/* service info in separate cards */}
            <div className="flex items-end">
                <ServiceInfoCard data={data} />
            </div>

            {/* section action buttons */}
            <ActionArea
                handleReload={handleReload}
                openModal={openModal}
                showMenu={showMenu}
                setShowMenu={setShowMenu}
            />
        </div>
    );
}

export default ServiceInfo;
